import React, { useEffect } from 'react'
import { FaWallet } from 'react-icons/fa'
import { Box, Stack, Icon, Progress, Heading, Text, Button } from '@/components/lib'
import api from '../../api'
import useStore from '../../store'
import utils from '../../utils/utils'

import PlansImage from '../../images/plans2.png'

export default function Overview () {
  const { user, team, updateTeam } = useStore()
  const teamId = team?._id

  // Refresh team data in case changed since /users/me called.
  useEffect(() => {
    if (!teamId) return
    api.teams.get(teamId, teamData => {
      updateTeam(teamData)
    })
  }, [teamId])

  return (
    <Stack gap={5}>
      {utils.hasPermission(user, 'team.manage', team?._id)
        ? (
          <>
            <Stack gap={5} direction={{ base: 'column', md: 'row' }}>
              <Stack gap={5} p={3} rounded='md' bg='bg.surface' minW='300px' borderWidth='1px'>
                <Heading size='md'>General usage</Heading>
                <TeamUsage title='Team seats (users)' count={team.userCount} maxCount={team.maxUsers} />
                <TeamUsage title='Trials' count={team.trialCount} maxCount={team.maxTrials} />
                <TeamUsage title='Participants' count={team.participantCount} maxCount={team.maxParticipants} />
              </Stack>

              <Stack gap={5} p={3} rounded='md' bg='bg.surface' borderWidth='1px'>
                <Heading size='md'>Communication (last 30 days)</Heading>
                <Stack spacing={3} direction={{ base: 'column', md: 'row' }}>
                  <Stack gap={4} p={2} bg='bg.muted' rounded='md' shadow='md' minW='200px' maxW='300px'>
                    <Heading size='sm'>Text messages</Heading>
                    <Text fontSize='sm' color='fg.muted'>Message volume over the last 30 days.</Text>
                    {utils.hasFeature(team, 'sms')
                      ? (
                        <Stack gap={2}>
                          <Text fontWeight='bold'>{team.smsCount30Days} SMS messages sent</Text>
                          <Stack direction='row' alignItems='center' gap={2}>
                            <Icon as={FaWallet} color='fg.subtle' />
                            <Text fontSize='sm' color='fg.muted'>SMS messages spend from each trial's wallet.</Text>
                          </Stack>
                        </Stack>)
                      : <Text fontSize='sm' color='fg.muted'>SMS is not enabled for your team.</Text>}
                  </Stack>

                  <Stack gap={4} p={2} bg='bg.muted' rounded='md' shadow='md' minW='200px' maxW='300px'>
                    <Heading size='sm'>WhatsApp</Heading>
                    <Text fontSize='sm' color='fg.muted'>Message volume over the last 30 days.</Text>
                    {utils.hasFeature(team, 'whatsapp')
                      ? (
                        <Stack gap={2}>
                          <Text fontWeight='bold'>{team.whatsappCount30Days} WhatsApp messages sent</Text>
                          <Stack direction='row' alignItems='center' gap={2}>
                            <Icon as={FaWallet} color='fg.subtle' />
                            <Text fontSize='sm' color='fg.muted'>WhatsApp messages spend from each trial's wallet.</Text>
                          </Stack>
                        </Stack>)
                      : <Text fontSize='sm' color='fg.muted'>WhatsApp is not enabled for your team.</Text>}
                  </Stack>

                  <Stack spacing={3} flex={1}>
                    <Stack gap={2} p={2} bg='bg.muted' rounded='md' shadow='md' minW='200px' maxW='300px'>
                      <Heading size='sm'>Emails</Heading>
                      <Text fontSize='sm' color='fg.muted'>Emails are non-metered.</Text>
                      <Text fontSize='sm' fontWeight='bold'>{team.email30Days} emails sent</Text>
                    </Stack>
                    <Stack gap={2} p={2} bg='bg.muted' rounded='md' shadow='md' minW='200px' maxW='300px'>
                      <Heading size='sm'>Push notifications</Heading>
                      <Text fontSize='sm' color='fg.muted'>Push notifications are non-metered.</Text>
                      <Text fontSize='sm' fontWeight='bold'>{team.push30Days} notifications sent</Text>
                    </Stack>

                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            <Stack direction={{ base: 'column', md: 'row' }} flex={1} p={3} rounded='md' borderWidth='1px' alignItems='center'>
              <Box>
                <img src={PlansImage} style={{ maxWidth: '300px' }} />
              </Box>
              <Stack gap={3} flex={1}>
                <Heading size='md'>Need new features or limits?</Heading>
                <Text>Let us know and we'll work with you to find a solution.</Text>
                <Box>
                  <Button colorPalette='primary' size='sm' as='a' variant='outline' href={`mailto:hello@trialflare.com?subject=Plan%20Change%20(${team?.name})`}>Talk to us about your plan</Button>
                </Box>
              </Stack>
            </Stack>
          </>)
        : (
          <Box>
            <Heading>Page unavailable</Heading>
            <Text>This page is only viewable by users that manage the team</Text>
          </Box>)}
    </Stack>
  )
}

function TeamUsage ({ title, count, maxCount }) {
  if (!maxCount) return null
  return (
    <Box>
      <Heading size='xs'>{title}</Heading>
      <Stack direction='row' alignItems='center'>
        <Progress w='100%' flex='1' colorPalette='primary' value={(count || 0) * 100 / maxCount} hasStripe size='md' roumded='md' />
        <Text w='100px' fontSize='sm'>{count || 0} / {maxCount}</Text>
      </Stack>
    </Box>
  )
}
